import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import {
  faArrowDown,
  faAward,
  faBell,
  faBookOpen,
  faExclamationTriangle,
  faHandsHelping,
  faLightbulb,
  faPaperPlane,
  faPlus,
  faQuoteRight,
  faTrashAlt
} from '@fortawesome/free-solid-svg-icons';

export class FontaAwesomeConfig {
  static configure(library: FaIconLibrary) {
    library.addIcons(faArrowDown);
    library.addIcons(faBookOpen);
    library.addIcons(faLightbulb);
    library.addIcons(faHandsHelping);
    library.addIcons(faAward);
    library.addIcons(faPaperPlane);
    library.addIcons(faQuoteRight);
    library.addIcons(faExclamationTriangle);
    library.addIcons(faTrashAlt);
    library.addIcons(faBell);
    library.addIcons(faPlus);
  }
}
